import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage"]

  changeImage(event) {
    event.preventDefault()
    
    // Get the image URL from the clicked thumbnail
    const imageUrl = event.currentTarget.getAttribute('data-product-gallery-image-url-value')

    // Find the image element inside the main image container and update its src
    const imageElement = this.mainImageTarget.querySelector("img")
    if (imageElement) {
      imageElement.src = imageUrl
    }
    
    // Update active thumbnail styling
    const buttons = this.element.querySelectorAll("button")

    buttons.forEach(button => {
      button.classList.remove("border-primary-500")
      button.classList.add("border-transparent", "hover:border-gray-300", "dark:hover:border-gray-700")
    })
    
    // Add active styling to the clicked thumbnail
    event.currentTarget.classList.remove("border-transparent", "hover:border-gray-300", "dark:hover:border-gray-700")
    event.currentTarget.classList.add("border-primary-500")
  }
} 
